import Vue from 'vue';
import Vuex from 'vuex';
import VueTheMask from 'vue-the-mask'


import state from './state';
import actions from './actions';

import mutations from './mutations';
import getters from './getters';

import 'date-input-polyfill';

import { SolicitacaoPagamento } from "./modules/solicitacao-de-pagamento"



Vue.use(VueTheMask)
Vue.use(Vuex);


const store = new Vuex.Store({
    state,
    actions,
    mutations,
    getters,
    modules: {
        SolicitacaoPagamento
    }
});

store.dispatch('updateDateTime');

(async () => {
    await store.dispatch('refresh');
    store.commit('setLoading', false);
})();


export default store;
export const useStore = () => store